import { polyfill } from 'es6-promise'
import { BACKEND_URL } from '../env'; polyfill()
const Vue = require('vue')
export class LektoratService {
  static get entity () {
    return 'lektorat'
  }

  static fixRunningText (data) {
    // console.log('service:  ' + data)
    return new Promise((resolve, reject) => {
      const myHeaders = new Headers()
      let token = Vue.default.cookie.get('token')
      if (!token) {
        token = localStorage.getItem('genderAppToken')
      }
      myHeaders.append('Authorization', `Token ${token}`)
      myHeaders.append('Content-Type', 'application/json')
      const raw = JSON.stringify({ runningText: data, wordTypesToAnalyse: ['N', 'ADJ', 'ART', 'PRO'], expectedReturnElements: ['entries'] })
      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
      }
      fetch(BACKEND_URL + '/dictionary_entry/fix_running_text/', requestOptions)
        .then(res => resolve(res.json())).catch(function (err) {
          console.log(err)
          // eslint-disable-next-line prefer-promise-reject-errors
          return reject('No server connection')
        })
    })
  }
}
